import { ReportTaxProps } from "./types";
import classes from "./report-tax.module.scss";

export const ReportTax = ({
    amount = 970,
    regionNote = "По данным на 2025 год в Москве и Московской области."
}: ReportTaxProps) => {
    return (
        <div className={classes["report-tax"]}>
            <div className={classes["report-tax__amount"]}>
                {amount.toLocaleString("ru-RU")} ₽ в год
            </div>
            <div className={classes["report-tax__note"]}>{regionNote}</div>
        </div>
    );
};